import React from 'react'
import SubLayout from '../../components/Layout/SubLayout'
import strings from "../../components/Language";
import _ from 'lodash';

//  CSS
import './../../assets/styles/style.scss';
import './wallet.scss';
import { Link } from 'react-router-dom';
import { IconChevronRight } from '../../components/Icons';
import { Button } from 'antd';
import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData, getUserData } from './../../components/Util';

import Modal from '@mui/material/Modal';
import { QrReader } from 'react-qr-reader';
import LoaderContext from '../../components/Loader/LoaderContext.js';

class TransferScreen extends React.Component {

    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            access_token: "",
            username: "",
            amount: '',
            verification_code: '',
            otp_code: '',
            user_data: {},
            isModal: false,
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            setTimeout(() => {
                this.setState({
                    access_token: token
                });
                var rowData = getUserData();
                if (rowData.data) {
                    this.setState({
                        user_data: rowData.data
                    });
                }
            });
        }
    }

    sendCode() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            setLoading(true);
            axios({
                method: 'POST',
                url: api.transfer_send_code,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage()
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                    self.setState({ otp_code: ress.data.data.otp_code });
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                }
                setLoading(false);
            }).catch(function (e) {
                setLoading(false);
            });
        }
    };

    sendData() {
        var self = this;
        if (self.state.access_token) {

            var json = {
                username: self.state.username,
                amount: self.state.amount,
                verification_code: self.state.verification_code,
            }
            const { setLoading } = this.context;
            setLoading(true);

            self.setState({ loading: true });
            axios({
                method: 'POST',
                url: api.transfer_store,
                data: json,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage()
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                    setLoading(false);
                    toast.success(ress.data.message);
                    self.props.history.replace({ pathname: `/transfer-details` })
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                    setLoading(false);
                }
                setLoading(false);
                self.setState({ loading: false });
            }).catch(function (e) {
                setLoading(false);
                self.setState({ loading: false });
            });
        }
    };

    closeModal() {
        var self = this;
        self.setState({
            isModal: false,
        });
    }

    render() {
        const availableUsdt = (this.state.user_data && this.state.user_data.credit && this.state.user_data.credit.usdt)
            ? parseFloat(this.state.user_data.credit.usdt).toFixed(5)
            : "0.00000";

        return (
            <>
                <SubLayout ref={this.wrapper} data={{ "title": strings.transfer }}>
                    <div className='wallet-page'>
                        <div className='wallet-form-shell'>
                            <div className='wl-toolbar wl-toolbar-end'>
                                <Link to={"/transfer-details"} className='wl-link-chip'>
                                    {strings.transfer_details}<IconChevronRight size={14} strokeWidth={2.2} />
                                </Link>
                            </div>

                            <div className='wallet-form-card'>
                                <div className='wallet-form-intro'>
                                    <div>
                                        <h3>{strings.confirm_transfer}</h3>
                                        <p>Review the recipient, amount and verification code before submitting.</p>
                                    </div>
                                </div>

                                <div className='wallet-form-grid'>
                                    <div className='wallet-field'>
                                        <label>{strings.Receipient_UserID}</label>
                                        <div className='wallet-input-wrap'>
                                            <input
                                                name='username'
                                                onChange={e => this.setState({ username: e.target.value })}
                                                value={this.state.username}
                                                placeholder={strings.please_enter_receipient_UserID}
                                            />
                                        </div>
                                        <div className='wallet-field-note'>{strings.receiver_name}: TEST 001</div>
                                    </div>

                                    <div className='wallet-field'>
                                        <label>{strings.transfer_quantity}</label>
                                        <div className='wallet-input-wrap'>
                                            <input
                                                name='amount'
                                                onChange={e => this.setState({ amount: e.target.value })}
                                                value={this.state.amount}
                                                placeholder={strings.minimum_withdraw_amount}
                                            />
                                            <button
                                                type="button"
                                                className='wallet-inline-action'
                                                onClick={() => this.setState({ amount: availableUsdt })}
                                            >
                                                {strings.All}
                                            </button>
                                        </div>
                                    </div>

                                    <div className='wallet-field'>
                                        <label>{strings.verification_code}</label>
                                        <div className='wallet-code-row'>
                                            <div className='wallet-input-wrap'>
                                                <input
                                                    type="text"
                                                    name='verification_code'
                                                    onChange={e => this.setState({ verification_code: e.target.value })}
                                                    value={this.state.verification_code}
                                                    placeholder={strings.verification_code_enter}
                                                />
                                            </div>
                                            <Button
                                                loading={this.state.loading_code}
                                                onClick={() => this.sendCode()}
                                                className='wallet-code-button'
                                            >
                                                {this.state.loading_code ? strings.loading : strings.send_code}
                                            </Button>
                                        </div>
                                    </div>

                                    <div className='wallet-summary'>
                                        <div className='wallet-summary-row'>
                                            <span>{strings.Available}</span>
                                            <strong>{availableUsdt} {strings.usdt}</strong>
                                        </div>
                                        <div className='wallet-summary-row'>
                                            <span>{strings.Transaction_Fees}</span>
                                            <strong>0 {strings.usdt}</strong>
                                        </div>
                                    </div>

                                    <Button
                                        className='wallet-primary-button'
                                        onClick={() => this.sendData()}
                                        loading={this.state.loading}
                                    >
                                        {(this.state.loading) ? strings.loading : strings.confirm_transfer}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </SubLayout>


                <Modal
                    open={this.state.isModal ?? false}
                    className="itemModal"
                    onClose={() => this.closeModal()}
                    style={{ overflow: 'scroll' }}
                >
                    <>
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content wl-modal">
                                <div className="modal-header" style={{ width: "100%" }}>
                                    <span>{strings.Scan_QR_Code}</span>
                                    <button onClick={() => this.closeModal()}
                                        type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        style={{ background: "transparent", borderWidth: 0 }}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body mt-4">
                                    <div>
                                        <QrReader
                                            style={{
                                                width: '100%',
                                            }}
                                            delay={300}
                                            facingMode="rear"
                                            onScan={(result, error) => {
                                                if (!!result) {
                                                    this.setState({
                                                        email: result.text,
                                                        isModal: false,
                                                    });
                                                }

                                                if (!!error) { }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </Modal>
            </>
        );
    }
}

export default TransferScreen;
